module.exports = __webpack_public_path__ + "static/img/book4.b11b3ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book4.jpg
// module id = D5i9
// module chunks = 1